
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NotFoundPage from './pages/NotFound';
import ResetPassword from './pages/ResetPassword';
import UpdatePassword from './pages/UpdatePassword';
import './index.css';

function App() {
  return (
    <Router>
      <Routes>
        < Route index path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route element={<ProtectedRoute />}>
          <Route index path="/" element={<Dashboard />} />
          {/* Other protected routes */}
          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes >
    </Router >
  )
}

export default App
